var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-view',[_c('icon-header',{attrs:{"title":_vm.userAgreement.name,"material-icon":"menu_book"}}),_c('user-agreement-content',{attrs:{"content":_vm.userAgreement.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }